
























































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Relative } from '@/types/user'
import { EventEmitter } from 'events'
import { DeleteConfirmResults } from '@/constants/utils'

enum EventTypes {
  CONFIRM_DELETE
}

@Component({
  components: {
    DeleteConfirmModal: () =>
      import('@/components/common/modals/AlertModal.vue')
  }
})
export default class RelativeIndex extends Vue {
  $store!: ExStore
  events = new EventEmitter()
  showDeleteConfirmModal = false

  get relatives() {
    return this.$store.getters['relative/relativeList']
  }

  handleDeleteConfirmOk() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.OK)
  }

  handleDeleteConfirmCancel() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.CANCEL)
  }

  async created() {
    await this.update()
  }

  async update() {
    await this.$store.dispatch('relative/updateList')
  }

  async deleteRelative(id: number) {
    this.showDeleteConfirmModal = true
    const resust = await new Promise<DeleteConfirmResults>(resolve =>
      this.events.once(EventTypes.CONFIRM_DELETE, resolve)
    )
    this.showDeleteConfirmModal = false
    if (resust === DeleteConfirmResults.CANCEL) {
      return
    }
    this.$store.dispatch('relative/delete', { id })
  }

  async showAdd() {
    this.$store.commit('user/deleteSessionData', 'newRelative')
    this.$router.push({ name: 'PatientRelativeAdd' })
  }

  async showComplete(relative: Relative) {
    const res = await this.$api.user.fetchRelativeRegistration({
      relativeId: relative.id
    })
    this.$store.commit('user/setSessionData', {
      createdRelative: Object.assign(relative, res)
    })
    this.$router.push({ name: 'PatientRelativeComplete' })
  }

  async showEdit(relative: Relative) {
    this.$store.commit('user/setSessionData', {
      newRelative: relative
    })
    this.$router.push({ name: 'PatientRelativeAdd' })
  }
}
